export default __webpack_public_path__ + "static/media/No-History.6d249428.png";